export const calculateNextOffsetToLeft = (offset, outerWidth, innerWidth) => {
  // When scroll is not allowed
  if (outerWidth >= innerWidth) {
    return 0;
  }

  // When scroll to left is not possible
  if (offset <= 0) {
    return 0;
  }

  return Math.max(offset - outerWidth, 0);
};

export const calculateNextOffsetToRight = (offset, outerWidth, innerWidth) => {
  // When scroll is not allowed
  if (outerWidth >= innerWidth) {
    return 0;
  }

  // When scroll to right is not possible
  if (offset + outerWidth >= innerWidth) {
    return innerWidth - outerWidth;
  }

  return Math.min(offset + outerWidth, innerWidth - outerWidth);
};

export const closestToOffset = offset => (threshold, index, thresholds) =>
  offset >= threshold &&
  offset < (index + 1 >= thresholds.length ? Infinity : thresholds[index + 1]);

export const snapToThreshold = (offset, thresholds) =>
  thresholds.find(closestToOffset(offset)) || thresholds[0] || 0;

export const shiftThresholdToLeft = (threshold, innerWidth, outerWidth, thresholds) => {
  const currentIndex = thresholds.indexOf(threshold);
  if (currentIndex === -1) return threshold;
  const prevThreshold = thresholds[currentIndex - 1] || thresholds[0];
  const nextThreshold = thresholds[currentIndex + 1] || innerWidth;
  const width = nextThreshold - prevThreshold;
  return width <= outerWidth ? prevThreshold : threshold;
};

export const shiftThresholdToRight = (threshold, innerWidth, outerWidth, thresholds) => {
  const currentIndex = thresholds.indexOf(threshold);
  if (currentIndex === -1) return threshold;
  const nextThreshold = thresholds[currentIndex + 1] || thresholds[thresholds.length - 1];
  const nextNextThreshold = thresholds[currentIndex + 2] || innerWidth;
  const width = nextNextThreshold - threshold;
  return width <= outerWidth ? nextThreshold : threshold;
};
